var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"invite",on:{"click":_vm.popShare}},[_c('img',{attrs:{"src":require("@/assets/img/patternSG.png")}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('邀請好友加入'))}}),_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-chevron-right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }